module.exports = __webpack_public_path__ + "static/GunoorKaur.4890e7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/GunoorKaur.jpg
// module id = 240
// module chunks = 25111403944408 251948199435738